import { render, staticRenderFns } from "./CustomFieldItems.vue?vue&type=template&id=1177bfdc&"
import script from "./CustomFieldItems.vue?vue&type=script&lang=js&"
export * from "./CustomFieldItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports